export default __webpack_public_path__ + "static/media/banner.83c7b98e.jpg";